import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let swipers = document.querySelectorAll('[paws-component="noss-slider"][paws-template="default"] .swiper');

    for (let i = 0; i < swipers.length; ++i) {
        let config = {
            effect: 'fade',
            slidesPerView: 1,
            autoplay: {
                delay: 5000
            },
            loop: true,
            on: {
                init: function () {
                    if (window.lazyLoadInstance) {
                        window.lazyLoadInstance.update();
                    }
                },
            },
        }

        let paginationEl = swipers[i].closest('[paws-component]').querySelector('.swiper-pagination');
        if (paginationEl !== null) {
            config.pagination = {el: paginationEl, clickable: true};
        }

        let navigationEl = swipers[i].closest('[paws-component]').querySelector('.swiper-navigation');
        if (navigationEl !== null) {
            let nextEl = swipers[i].closest('[paws-component]').querySelector('.btn-next');
            let prevEl = swipers[i].closest('[paws-component]').querySelector('.btn-prev');
            config.navigation = {nextEl: nextEl, prevEl: prevEl};
        }

        let mySwiper = new Swiper(swipers[i], config);
    }
}